module.exports = __webpack_public_path__ + "static/media/ground.680969f2.webp";